import { useEffect } from 'react';
import Stack from '@mui/material/Stack';

import useDispatch from 'shared/hooks/useDispatch';

import { keyOrdersApi } from './api';

import StyledFiltersBar from 'shared/components/styled/FiltersBar';
import PageLayout from 'layouts/PageLayout';
import TopBar from './components/TopBar';
import KeyOrdersGrid from './components/KeyOrdersGrid';
import SearchBar from './components/SearchBar';

const KeyOrders = () => {
  const dispatch = useDispatch();

  const { isLoading, isFetching, isError } =
    keyOrdersApi.useGetKeyOrdersListQuery();

  useEffect(() => {
    return () => {
      dispatch(keyOrdersApi.util.resetApiState());
    };
  }, []);

  return (
    <PageLayout isLoading={isLoading} isError={isError}>
      <Stack spacing={2}>
        <TopBar />
        <StyledFiltersBar
          alignItems="center"
          direction="row"
          justifyContent="flex-end"
        >
          <SearchBar />
        </StyledFiltersBar>
        <KeyOrdersGrid isFetching={isFetching} />
      </Stack>
    </PageLayout>
  );
};

export default KeyOrders;
